import { render } from "./Header.vue?vue&type=template&id=022e3248"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=022e3248&lang=scss"
script.render = render

export default script